import React, { useState, useEffect } from 'react';
import { FaBuilding } from 'react-icons/fa';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import useAxios from '../utils/useAxios';

const OrganisationSelector = ({ onOrganisationChange, selectedOrganisation: externalSelectedOrg }) => {
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState(externalSelectedOrg || '');
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentOrganisation, setCurrentOrganisation] = useState(null);
  const [loading, setLoading] = useState(true);
  const axiosInstance = useAxios();

  // Récupérer toutes les organisations
  const fetchOrganisations = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/organisations/');
      setOrganisations(response.data);
      
      // Sélectionner automatiquement la première organisation si aucune n'est fournie
      if (response.data.length > 0 && !externalSelectedOrg) {
        const firstOrg = response.data[0];
        setSelectedOrganisation(firstOrg.id);
        setCurrentOrganisation(firstOrg);
        if (onOrganisationChange) {
          onOrganisationChange(firstOrg.id, firstOrg);
        }
      } else if (externalSelectedOrg) {
        // Si une organisation est fournie en prop, trouver l'objet correspondant
        const org = response.data.find(o => o.id === externalSelectedOrg);
        setCurrentOrganisation(org);
      }
    } catch (err) {
      console.error("Erreur lors de la récupération des organisations", err);
    } finally {
      setLoading(false);
    }
  };

  // Sélectionner une organisation
  const selectOrganisation = (orgId) => {
    const org = organisations.find(o => o.id === orgId);
    setSelectedOrganisation(orgId);
    setCurrentOrganisation(org);
    setShowDropdown(false);
    
    if (onOrganisationChange) {
      onOrganisationChange(orgId, org);
    }
  };

  useEffect(() => {
    fetchOrganisations();
  }, []);

  // Mettre à jour si la prop selectedOrganisation change
  useEffect(() => {
    if (externalSelectedOrg && externalSelectedOrg !== selectedOrganisation) {
      const org = organisations.find(o => o.id === externalSelectedOrg);
      setSelectedOrganisation(externalSelectedOrg);
      setCurrentOrganisation(org);
    }
  }, [externalSelectedOrg, organisations]);

  if (loading) {
    return <div>Chargement des organisations...</div>;
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        style={{
          padding: '12px 20px',
          border: '2px solid #1B019B',
          borderRadius: '8px',
          backgroundColor: '#fff',
          color: '#1B019B',
          fontWeight: '600',
          fontSize: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          minWidth: '300px'
        }}
      >
        <FaBuilding />
        {currentOrganisation ? currentOrganisation.nom : 'Sélectionner une organisation'}
        {showDropdown ? <FiChevronUp /> : <FiChevronDown />}
      </button>
      
      {showDropdown && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '2px solid #1B019B',
          borderTop: 'none',
          borderRadius: '0 0 8px 8px',
          maxHeight: '200px',
          overflowY: 'auto',
          zIndex: 1000
        }}>
          {organisations.map(org => (
            <div
              key={org.id}
              onClick={() => selectOrganisation(org.id)}
              style={{
                padding: '12px 20px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                backgroundColor: selectedOrganisation === org.id ? '#f0f0ff' : '#fff',
                color: selectedOrganisation === org.id ? '#1B019B' : '#333',
                fontWeight: selectedOrganisation === org.id ? '600' : '400'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9ff'}
              onMouseLeave={(e) => e.target.style.backgroundColor = selectedOrganisation === org.id ? '#f0f0ff' : '#fff'}
            >
              {org.nom}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrganisationSelector;